export default __webpack_public_path__ + "static/media/boom-shakka-lakka.eb117a1d.gif";